<template>
  <card-item card="item_dealer" :tabs="tabs" :activeTab="activeTab" :id="id">
  
  </card-item>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          component: () => import("./Info"),
        },
        {
          title: "Магазины",
          component: () => import("./Shops"),
        },
        {
          title: "Заказы",
          component: () => import("./Orders"),
        },
        {
          title: "Транзакции",
          component: () => import("./Transactions"),
        },
        {
          title: "Установить пароль",
          component: () => import("./Password"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>